import React, { useState, useEffect } from 'react';
import { Skeleton, Typography } from '@mui/material';
import { getDoc } from 'firebase/firestore';

const ViewUser = ({ userRef }) => {
  const [userData, setUserData] = useState(null);
  // const supplierDocRef = doc(db, 'suppliers', supplierId);
  // const supplierDocRef = getDoc(supplierRef);
  // const [supplierData, loading] = useDocumentData(supplierRef ?? null);
  useEffect(() => {
    // console.log(customerRef);
    const fetchUser = async () => {
      const userSnap = await getDoc(userRef);
      // console.log(userSnap.data());
      if (userSnap.exists()) {
        setUserData(userSnap.data());
      }
    };
    if (userRef.id) {
      fetchUser().then();
    }
  }, [userRef]);
  if (!userData && userRef.id)
    return (
      <Skeleton
        variant={'text'}
        height={24}
        animation={'wave'}
      />
    );
  if (userData) return <Typography component={'div'}>{userData.displayName}</Typography>;
};

export default ViewUser;
